import fetch from '../utils/fetch'

export function activate (query) {
  return fetch({
    url: '/company/activate',
    method: 'post',
    data: query
  })
}

export function getActivateInfo () {
  return fetch({
    url: '/company/activate',
    method: 'get',
  })
}
export function ydleadsInfo (data) {
  return fetch({
    url: '/ydleads/create',
    method: 'post',
    data
  })
}

export function getResourceList (query) {
  return fetch({
    url: '/company/resources',
    method: 'get',
    params: query
  })
}

export function updateCompanyInfo (query) {
  return fetch({
    url: '/company',
    method: 'patch',
    data: query
  })
}

//以下为账号管理接口

export function createAccount (query) {
  return fetch({
    url: '/account/management',
    method: 'post',
    data: query
  })
}

export function getAccountInfo (id) {
  return fetch({
    url: '/account/management/' + id,
    method: 'get',
  })
}

export function getAccountList (query) {
  return fetch({
    url: '/account/management',
    method: 'get',
    params: query
  })
}

export function updateAccountInfo (id, query) {
  return fetch({
    url: '/account/management/' + id,
    method: 'patch',
    data: query
  })
}

export function deleteAccountInfo(id){
  return fetch({
    url: '/account/management/' + id,
    method: 'delete'
  })
}

// 更新企业会员账号状态
export function accountChangeStatus(id, data){
  return fetch({
    url: `/account/change/status/${id}`,
    method: 'put',
    data
  })
}

//以下为角色管理接口

export function createRoles (query) {
  return fetch({
    url: '/roles/management',
    method: 'post',
    data: query
  })
}

export function getRolesInfo (id) {
  return fetch({
    url: '/roles/management/'+id,
    method: 'get',
  })
}

export function getRolesList (query) {
  return fetch({
    url: '/roles/management',
    method: 'get',
    params: query
  })
}

export function updateRolesInfo (id, query) {
  return fetch({
    url: '/roles/management/'+ id,
    method: 'patch',
    data: query
  })
}

export function deleteRole (id) {
  return fetch({
    url: '/roles/management/'+id,
    method: 'delete',
  })
}

export function getPermissionList (query) {
  return fetch({
    url: '/permission',
    method: 'get',
    params: query
  })
}

export function createCurrencyInfo (query) {
  return fetch({
    url: '/currency',
    method: 'post',
    data: query
  })
}

export function deleteCurrencyInfo (id) {
  return fetch({
    url: '/currency/'+id,
    method: 'delete',
  })
}

export function updateCurrencyInfo (id, query) {
  return fetch({
    url: '/currency/' + id,
    method: 'put',
    data: query
  })
}

export function getCurrencytLists (query) {
  return fetch({
    url: '/currency',
    method: 'get',
    params: query
  })
}
export function getCurrencytInfo (id) {
  return fetch({
    url: '/currency/' +id,
    method: 'get',
  })
}

export function setDefaultCurrency(id) {
  return fetch({
    url: '/currencySetDefault/' + id,
    method: 'put',
  })
}

export function getDefaultCurrency() {
  return fetch({
    url: '/currencyGetDefault',
    method: 'get'
  })
}

export function setCompanySetting(query) {
  return fetch({
    url: '/company/setting',
    method: 'post',
    data: query
  })
}

export function getCompanySetting() {
  return fetch({
    url: '/company/setting',
    method: 'get'
  })
}

export function getCompanyStatistics() {
  return fetch({
    url: '/getStatistics',
    method: 'get'
  })
}

export function getSelfDeliveryAddress() {
  return fetch({
    url: '/setting/selfdelivery',
    method: 'get'
  })
}

export function setSelfDeliveryAddress(query) {
  return fetch({
    url: '/setting/selfdelivery',
    method: 'post',
    data: query
  })
}

export function shopLoginSelectShopId(query) {
  return fetch({
    url: '/operator/select/distributor',
    method: 'post',
    data: query
  })
}

export function getCompanysLogs(query) {
  var object = fetch({url: '/company/operatorlogs', method: 'get', params: query})
  return object.then(res => {
    return res.data.data
  })
}

export function getCertificate() {
  return fetch({
    url: '/third/saascert/certificate',
    method: 'get'
  })
}

export function deleteCertificateInfo() {
  return fetch({
    url: '/third/saascert/delete/certificate',
    method: 'get'
  })
}

export function bindRelation() {
  return fetch({
    url: '/third/saascert/apply/bindrelation',
    method: 'get'
  })
}

export function acceptRelation() {
  return fetch({
    url: '/third/saascert/accept/bindrelation',
    method: 'get'
  })
}

export function getWebUrlSetting() {
  return fetch({
    url: '/setting/weburl',
    method: 'get'
  })
}

export function saveWebUrlSetting(query) {
  return fetch({
    url: '/setting/weburl',
    method: 'post',
    data: query
  })
}

export function getRateSetting(){
  return fetch({
    url: '/traderate/setting',
    method: 'get',
  })
}
export function setRateSetting(query){
  return fetch({
    url: '/traderate/setting',
    method: 'post',
    data: query
  })
}
export function getShareSetting(params){
  return fetch({
    url: '/share/setting',
    method: 'get',
    params,
  })
}
export function setShareSetting(query){
  return fetch({
    url: '/share/setting',
    method: 'post',
    data: query
  })
}

export function getWhitelistSetting(){
  return fetch({
    url: '/member/whitelist/setting',
    method: 'get',
  })
}
export function setWhitelistSetting(query){
  return fetch({
    url: '/member/whitelist/setting',
    method: 'post',
    data: query
  })
}

export function getPickupcodeSetting(){
  return fetch({
    url: '/pickupcode/setting',
    method: 'get',
  })
}
export function setPickupcodeSetting(query){
  return fetch({
    url: '/pickupcode/setting',
    method: 'post',
    data: query
  })
}

export function getGiftSetting(){
  return fetch({
    url: '/gift/setting',
    method: 'get',
  })
}
export function setGiftSetting(query){
  return fetch({
    url: '/gift/setting',
    method: 'post',
    data: query
  })
}

export function getSendOmsSetting(){
  return fetch({
    url: '/sendoms/setting',
    method: 'get',
  })
}
export function setSendOmsSetting(query){
  return fetch({
    url: '/sendoms/setting',
    method: 'post',
    data: query
  })
}

export function getNoStores(){
  return fetch({
    url: '/nostores/setting',
    method: 'get',
  })
}
export function setNoStores(query){
  return fetch({
    url: '/nostores/setting',
    method: 'post',
    data: query
  })
}


export function getRechargeSetting(){
  return fetch({
    url: '/recharge/setting',
    method: 'get',
  })
}
export function setRechargeSetting(query){
  return fetch({
    url: '/recharge/setting',
    method: 'post',
    data: query
  })
}

export function getRepeatCancelSetting(){
  return fetch({
    url: '/trade/cancel/setting',
    method: 'get',
  })
}
export function setRepeatCancelSetting(query){
  return fetch({
    url: '/trade/cancel/setting',
    method: 'post',
    data: query
  })
}
export function forum(query){
  return fetch({
    url: '/company/forum',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/company.js